// 账号类型枚举值
export const ACCOUNT_TYPE = {
  // 企业
  ENT: 2,
  // 自由职业者
  ENG: 1,
};

export const ACCOUNT_TYPE_TEXT = {
  [ACCOUNT_TYPE.ENT]: "企业",
  [ACCOUNT_TYPE.ENG]: "自由职业者",
};

export const accountTypeOptions = [
  {
    label: ACCOUNT_TYPE_TEXT[ACCOUNT_TYPE.ENT],
    value: ACCOUNT_TYPE.ENT,
  },
  {
    label: ACCOUNT_TYPE_TEXT[ACCOUNT_TYPE.ENG],
    value: ACCOUNT_TYPE.ENG,
  },
];
